import { ColumnDef } from '@tanstack/react-table'
import { GetPlayWithReturnLossReceiveData } from '@/modules/manage-player/type'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { SortingArrows } from '@/common/components/SortingArrows'
import { PlayerTagsCell } from '@/common/components/PlayerTagsCell'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'
import AssignPlayerTagsModal from '@/modules/manage-player/components/GetPlayerList/components/GetPlayerListTable/CellAction/components/AssignPlayerTagsModal'
import type { PlayerTagResponse } from '@/modules/tags/types'

export const columns: ColumnDef<GetPlayWithReturnLossReceiveData>[] = [
	{
		accessorKey: 'username',
		header: 'ข้อมูลผู้เล่น',
		cell: ({ row }) => {
			const { id, username, phone, tags } = row.original
			return (
				<div className="space-y-1">
					<div className="block">
						<UsernameCell username={username} />
					</div>
					<div className="block">
						<PhoneCell playerId={id} phone={phone} />
					</div>
					<div className="block">
						<PlayerTagsCell tags={tags || []} />
					</div>
					<AssignPlayerTagsModal
						playerId={id}
						playerPhone={phone}
						currentTags={tags as unknown as PlayerTagResponse[]}
					/>
				</div>
			)
		},
	},
	{
		accessorKey: 'totalReturnLossAmount',
		header: ({ column }) => {
			return (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
					className="px-0 hover:bg-transparent"
				>
					ยอดรับคืนยอดเสีย (บาท)
					<SortingArrows sortOrder={column.getIsSorted()} />
				</Button>
			)
		},
		cell: ({ row }) => {
			const amountValue = Number(row.getValue('totalReturnLossAmount'))
			const amount = Number.isFinite(amountValue) ? amountValue : 0
			return (
				<div className="space-y-1 text-sm">
					<p>ยอดรับคืนยอดเสีย: {amount.toFixed(2)}</p>
					<p className="text-muted-foreground">
						จำนวนครั้ง: {row.original.totalReturnLossTime || 0}
					</p>
				</div>
			)
		},
	},

	{
		accessorKey: 'lastOnline',
		header: 'เวลา/การดำเนินการ',
		cell: ({ row }) => {
			const lastOnline = row.original.lastOnline
			return (
				<div className="space-y-1">
					<p className="text-xs text-muted-foreground">
						ออนไลน์ล่าสุด:{' '}
						{lastOnline
							? new Date(lastOnline).toLocaleDateString('th-TH', {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
								})
							: '-'}
					</p>
					<Button asChild variant="outline" size="sm">
						<Link
							to={`/operator/get-player-list/player-detail/${row.original.id}`}
						>
							ดูข้อมูลผู้เล่น
						</Link>
					</Button>
				</div>
			)
		},
	},
]
